/**
 * @generated SignedSource<<0df4878015ec9b958c66994f2d7524cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_workManagementBoard_BoardWithWorkflowsData_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueCreateProvider" | "IssueLinkingProvider" | "board_workManagementBoard_queryFragment">;
  readonly " $fragmentType": "src_workManagementBoard_BoardWithWorkflowsData_queryFragment";
};
export type src_workManagementBoard_BoardWithWorkflowsData_queryFragment$key = {
  readonly " $data"?: src_workManagementBoard_BoardWithWorkflowsData_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_workManagementBoard_BoardWithWorkflowsData_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_workManagementBoard_BoardWithWorkflowsData_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "board_workManagementBoard_queryFragment"
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueCreateProvider"
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueLinkingProvider"
    }
  ],
  "type": "Query"
};

(node as any).hash = "71a25acd1a93e221e52535cf54523e99";

export default node;
